import React from 'react'
import { Box, Grid, Typography } from '@mui/material'

export default function PageLayoutV2(props: IPageLayout) {
  const { header, children } = props

  return (
    <Grid
      container
      direction='column'
      justifyContent='flex-start'
      alignItems='stretch'
      spacing={2}
      sx={{ padding: 2 }}
    >
      <Grid item>
        <Typography variant='h4'>{header}</Typography>
      </Grid>
      <Grid item>
        <Box>{children}</Box>
      </Grid>
    </Grid>
  )
}

interface IPageLayout {
  header: string
  children: JSX.Element
}
